import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'habita.co';
const DEFAULT_TITLE = 'habita.co — Encuentra tu próximo hogar en Colombia';
const DEFAULT_DESC = 'Compra, arrienda o publica propiedades en las mejores zonas de Colombia. Más de 25.000 inmuebles verificados.';
const DEFAULT_IMG = 'https://images.unsplash.com/photo-1505843513577-22bb7d21e455?w=1200&q=80';
const SITE_URL = typeof window !== 'undefined' ? window.location.origin : 'https://habita.co';

export default function SEO({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMG,
  url,
  type = 'website',
  noindex = false,
  jsonLd,
}) {
  const fullTitle = title ? `${title} | ${SITE}` : DEFAULT_TITLE;
  const fullUrl = url || (typeof window !== 'undefined' ? window.location.href : SITE_URL);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={fullUrl} />

      {/* OpenGraph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="es_CO" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(prune(jsonLd))}</script>
      )}
    </Helmet>
  );
}

// Recursively drops keys whose value is null/undefined/'' so JSON-LD validators
// never see {image: null} or {addressLocality: null}.
function prune(obj) {
  if (Array.isArray(obj)) return obj.map(prune).filter(v => v !== undefined);
  if (obj && typeof obj === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(obj)) {
      if (v == null || v === '') continue;
      const cleaned = prune(v);
      if (cleaned && typeof cleaned === 'object' && !Array.isArray(cleaned) && Object.keys(cleaned).length === 0) continue;
      out[k] = cleaned;
    }
    return out;
  }
  return obj;
}
